<app-pias-layout>
    <div pias-layout-content>
        <div id="manage-users-container" class="container-fluid">
            <div id="manage-users-header">
                <h5 class="page-header">Manage Users</h5>
            </div>

            <div id="user-list-table-container">
                <form [formGroup]="userListFilterFg" class="row align-items-start">

                    <p class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 m-0">
                        <mat-form-field class="w-100">
                            <mat-label>Search keywork</mat-label>
                            <input matInput formControlName="searchKeyword" type="text" />
                        </mat-form-field>
                    </p>

                    <p class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 m-0">
                        <mat-form-field class="w-100">
                            <mat-label>User Role</mat-label>
                            <mat-select formControlName="userRole">
                                @for(role of this.userRoles; track role) {
                                <mat-option value="{{role.value}}">{{role.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </p>

                    <p class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 m-0">
                        <mat-form-field class="w-100">
                            <mat-label>User Status</mat-label>
                            <mat-select formControlName="userStatus">
                                @for(status of this.userStatus; track status) {
                                <mat-option value="{{status.value}}">{{status.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </p>

                    <p class="col-sm-12 col-md-6 col-lg-2 col-xxl-2 m-0">
                        <button type="submit" class="btn-pias"
                            (click)="this.__applyUserListFilter()">Search</button>
                    </p>

                    <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                        <button type="submit" class="btn-pias" [routerLink]="'/user/create-new-user'">Create New User</button>
                    </p>

                </form>
                <mat-card appearance="raised" class="pias-card mt-3">
                    <mat-card-content class="pias-card-content pias-table-container">
                        <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
                            [dataSource]="userListTableDataSource" matSort #userListTableSort="matSort">

                            <!-- SNo Column -->
                            <ng-container matColumnDef="sno">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> S.No. </th>
                                <td mat-cell *matCellDef="let userData; let i = index" class="text-center align-middle">
                                    {{i + 1}} </td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> Name </th>
                                <td mat-cell *matCellDef="let userData;" class="text-start align-middle">
                                    {{userData.personName}} </td>
                            </ng-container>

                            <!-- Email Address Column -->
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> Email Address </th>
                                <td mat-cell *matCellDef="let userData;" class="text-start align-middle">
                                    {{userData.email}} </td>
                            </ng-container>

                            <!-- Contact No. Column -->
                            <ng-container matColumnDef="contactNo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> Contact No. </th>
                                <td mat-cell *matCellDef="let userData;" class="text-start align-middle">
                                    {{userData.contactno}} </td>
                            </ng-container>

                            <!-- User Role Column -->
                            <ng-container matColumnDef="userCategory">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> User Role </th>
                                <td mat-cell *matCellDef="let userData;" class="text-center align-middle">
                                    {{userData.userCategory}} </td>
                            </ng-container>

                            <!-- User Status Column -->
                            <ng-container matColumnDef="isActive">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> User Status </th>
                                <td mat-cell *matCellDef="let userData;" class="text-center align-middle">
                                    @if(userData.isActive) {
                                    <span class="user-active">Active</span>
                                    }
                                    @else {
                                    <span class="user-inactive">Inactive</span>
                                    }
                                </td>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="text-center align-middle fw-bold"> Action </th>
                                <td mat-cell *matCellDef="let userData;" class="text-center">
                                    <button type="button" class="btn-pias-user-action">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" class="btn-pias-user-action">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="userListTableDisplayColumn; sticky: true">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: userListTableDisplayColumn;"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="11">No data found.</td>
                            </tr>
                        </table>

                        <!-- User List Table Paginator -->
                        <mat-paginator #userListTablePaginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons
                            aria-label="Select page ofuser list data"></mat-paginator>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</app-pias-layout>